import { Link } from "wouter";
import { PublicLayout } from "@/components/public/public-layout";
import {
  Container,
  Section,
  PageHero,
  SectionIntro,
} from "@/components/public/institutional-ui";
import { transactions } from "@/lib/site-content";
import { FadeIn } from "@/components/ui/scroll-animations";
import { ArrowRight } from "lucide-react";

export default function TransactionsPage() {
  return (
    <PublicLayout>
      <PageHero
        eyebrow="Track record"
        title="Selected transactions"
        description="Representative debt raises and structured financings across renewable energy, education, hospitality, and logistics."
      />

      <Section className="!pt-0" variant="muted">
        <Container>
          <div className="grid sm:grid-cols-2 gap-px bg-border border border-border">
            {transactions.map((tx, i) => (
              <FadeIn key={tx.label} delay={i * 0.06}>
                <div className="bg-background p-10 md:p-14">
                  <p className="gc-stat-value">{tx.amount}</p>
                  <p className="mt-4 text-muted-foreground leading-relaxed">{tx.label}</p>
                </div>
              </FadeIn>
            ))}
          </div>
        </Container>
      </Section>

      <Section>
        <Container className="text-center">
          <SectionIntro
            align="center"
            title="Discuss your capital requirement"
            description="Our team will review your mandate and respond within one business day."
          />
          <Link href="/contact">
            <span className="gc-btn-primary cursor-pointer inline-flex">
              Speak with us
              <ArrowRight className="ml-2 h-4 w-4" />
            </span>
          </Link>
        </Container>
      </Section>
    </PublicLayout>
  );
}
